import id from './id-ID';

export default { id };
